/**
 * Vehicle insurance claim record category values
 */
export enum VehicleInsuranceRecordCategoryEnum {
	VEHICLE = 'vehicle',
	RENTAL_AGREEMENT = 'rental_agreement',
}
